import { Component, Input, OnInit } from '@angular/core';
import { ICustomerEmailLookup } from 'lib-core-shared';

@Component({
  selector: 'app-duplicate-email-check',
  templateUrl: './duplicate-email-check.component.html',
  styleUrls: ['./duplicate-email-check.component.scss']
})

export class DuplicateEmailCheckComponent implements OnInit {
  @Input() emailMatches?: ICustomerEmailLookup[];
  @Input() checkedEmailAddress?: string;
  matches?: ICustomerEmailLookup[];
  constructor() { }

  ngOnInit(): void {
    this.removeContactsThatArentDefaulted(this.emailMatches);
  }

  removeContactsThatArentDefaulted(res: any) {
    let arr = res;
    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        if(arr[i].contact.length > 1) {
          for (let index = 0; index < arr[i].contact.length; index++) {
            if(arr[i].contact[index].isDefault === false) {
              arr[i].contact.splice(index, 1)
            }
          }
        }
      }
      this.matches = arr;
    }
  }
}
